import { render, staticRenderFns } from "./SendOrderByWhats.vue?vue&type=template&id=18eef587&"
import script from "./SendOrderByWhats.vue?vue&type=script&lang=js&"
export * from "./SendOrderByWhats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports